import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ToastHost } from './utils/notify';
import { installAuthInterceptor } from './utils/authInterceptor';

// ── Portail parent ──────────────────────────────────────────────────────────
// Page publique servie sur /parent/<slug>. On bifurque AVANT tout le reste :
//   - l'intercepteur d'authentification n'est PAS installé (il injecterait le
//     Bearer de l'école sur les appels /api/parent/*, ce qui n'a aucun sens et
//     ferait fuiter un jeton de personnel sur une page publique) ;
//   - le Service Worker n'est pas enregistré : le portail doit toujours refléter
//     l'état réel de la scolarité, jamais une copie mise en cache.
//
// ⚠️ `App` est chargé en LAZY, lui aussi. Un `import App from './App'` statique
// suffirait à embarquer TOUT le code d'administration dans le bundle initial —
// donc dans ce que télécharge un parent, souvent sur une connexion mobile.
// Les deux branches doivent rester paresseuses pour que la séparation existe
// réellement (vérifiable : `npm run build` sort un chunk distinct par branche).
const estPortailParent = window.location.pathname.startsWith('/parent');
const App = React.lazy(() => import('./App'));
const PortailParent = React.lazy(() => import('./portail-parent/PortailParent'));

const Attente = (
  <div style={{ padding: 40, textAlign: 'center', fontFamily: 'system-ui, Arial, sans-serif', color: '#7f8c8d' }}>
    Chargement…
  </div>
);

if (!estPortailParent) {
  // Injecte le Bearer token sur tous les appels API. DOIT etre installe avant tout
  // rendu / tout fetch (l'API n'accepte plus les requetes anonymes).
  installAuthInterceptor();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    {estPortailParent ? (
      <React.Suspense fallback={Attente}>
        <PortailParent />
      </React.Suspense>
    ) : (
      <React.Suspense fallback={Attente}>
        <App />
        <ToastHost />
      </React.Suspense>
    )}
  </React.StrictMode>
);

// Enregistrement du Service Worker (PWA)
if ('serviceWorker' in navigator && !estPortailParent) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        console.log('✅ Service Worker enregistré');

        // Écouter les messages du SW (mise à jour disponible)
        navigator.serviceWorker.addEventListener('message', (event) => {
          if (event.data?.type === 'SW_UPDATED') {
            // Recharger la page pour charger le nouveau code
            window.location.reload();
          }
        });

        // Vérifier les mises à jour toutes les 60 secondes
        setInterval(() => reg.update(), 60_000);
      })
      .catch(err => console.warn('⚠️ Service Worker non enregistré:', err));
  });
}
